"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aborted = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const Aborted = ({ colour = "currentcolor", size = 16, title }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true, stroke: colour, fill: "none", title: title },
    react_1.default.createElement("circle", { r: "6", cx: "8", cy: "8", strokeWidth: "2" }),
    react_1.default.createElement("path", { d: "M8,11.5 5,6 11,6Z", strokeWidth: "1.5" })));
exports.Aborted = Aborted;
//# sourceMappingURL=Aborted.js.map